import React from 'react';

interface ChevronArrowProps {
  readonly width?: string;
  readonly height?: string;
  readonly rotateDegrees?: string;
}

const ChevronArrow: React.FC<ChevronArrowProps> = (props) => {
  const {width, height, rotateDegrees} = props;
  const styles = {
    transform: `rotate(${rotateDegrees ? rotateDegrees : '0'}deg)`,
  };

  return (
    <svg
      style={styles}
      className="chevron-arrow"
      width={width ? width : '22'}
      height={height ? height : '11'}
      viewBox="0 0 22 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0004 11.813C10.5504 11.813 10.1274 11.635 9.81139 11.313L0.0253906 1.31599L0.975391 0.385986L10.7604 10.382C10.8904 10.513 11.1094 10.514 11.2404 10.381L21.0244 0.385986L21.9754 1.31599L12.1904 11.312C11.8734 11.636 11.4504 11.813 11.0004 11.813Z"
        fill="#001E50"
      />
    </svg>
  );
};

export default ChevronArrow;
